import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button onClick={() => scrollToSection('inicio')} className="flex items-center bg-white rounded px-2 py-1">
            <img 
              src="/logo.png" 
              alt="FP Estudio Jurídico" 
              className="h-10 w-auto object-contain"
            />
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('inicio')}
              className="text-gray-200 hover:text-blue-400 font-medium transition-colors"
            >
              Inicio
            </button>
            <button 
              onClick={() => scrollToSection('areas')}
              className="text-gray-200 hover:text-blue-400 font-medium transition-colors"
            >
              Áreas de Práctica
            </button>
            <button 
              onClick={() => scrollToSection('nosotros')}
              className="text-gray-200 hover:text-blue-400 font-medium transition-colors"
            >
              Sobre Nosotros
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="text-gray-200 hover:text-blue-400 font-medium transition-colors"
            >
              Preguntas Frecuentes
            </button>
            <Button 
              onClick={() => scrollToSection('contacto')}
              className="bg-gray-700 hover:bg-gray-600 text-white"
            >
              Contacto
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden bg-slate-900 border-t border-slate-800">
            <nav className="flex flex-col space-y-4 py-6">
              <button 
                onClick={() => scrollToSection('inicio')}
                className="text-gray-200 hover:text-blue-400 font-medium transition-colors text-left px-4"
              >
                Inicio
              </button>
              <button 
                onClick={() => scrollToSection('areas')}
                className="text-gray-200 hover:text-blue-400 font-medium transition-colors text-left px-4"
              >
                Áreas de Práctica
              </button>
              <button 
                onClick={() => scrollToSection('nosotros')}
                className="text-gray-200 hover:text-blue-400 font-medium transition-colors text-left px-4"
              >
                Sobre Nosotros
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className="text-gray-200 hover:text-blue-400 font-medium transition-colors text-left px-4"
              >
                Preguntas Frecuentes
              </button>
              <div className="px-4">
                <Button 
                  onClick={() => scrollToSection('contacto')}
                  className="w-full bg-gray-700 hover:bg-gray-600 text-white"
                >
                  Contacto
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
